import { render, staticRenderFns } from "./TruncatedText.vue?vue&type=template&id=e8417ce4&scoped=true"
import script from "./TruncatedText.vue?vue&type=script&lang=js"
export * from "./TruncatedText.vue?vue&type=script&lang=js"
import style0 from "./TruncatedText.vue?vue&type=style&index=0&id=e8417ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8417ce4",
  null
  
)

export default component.exports